import type { IPathBaseParam } from "./path";
import type { ICourseSessionsGetAllParams } from "./types";

import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import type { ICourseSessionResponse } from "@api/courses/sessions/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICourseSessionResponse>>,
  IPathBaseParam,
  IPaginationParams & ICourseSessionsGetAllParams
>("sessions");

export const sessions = {
  ...getAllApis,
};
